export const ALL_BLOGS = 'ALL_BLOGS';
export const CATEGORY = 'CATEGORY';
export const AUTHOR = 'AUTHOR';
export const QUERY = 'QUERY';
